// LiveBar — thin status strip shown while the live bridge is the active
// source. Renders only real connection state from the websocket source slice.
// (Artifact freshness / "re-proved N seconds ago" needs the bridge to
// timestamp scenario-update messages in the store — not yet available, so it
// is deliberately absent rather than faked.)

import { useSelector } from 'react-redux';
import { selectWebSocketState } from '../../store/slices/scenarioSourceSlice.ts';

export default function LiveBar() {
  const ws = useSelector(selectWebSocketState);
  if (ws.connectionStatus !== 'connected') return null;
  const spec = ws.specFile ? (ws.specFile.split('/').pop() ?? ws.specFile) : null;
  return (
    <div className="fv2-live-bar">
      <span style={{ color: 'var(--green)' }}>● LIVE</span>
      {spec && <span className="fv2-live-spec">{spec}</span>}
      <span className="fv2-dim">
        {ws.secure ? 'wss' : 'ws'}://{ws.host}:{ws.port}
      </span>
      <span className="fv2-live-note">every save re-parses, re-derives, and replays the suite</span>
    </div>
  );
}
